var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwygsAvatarNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 22.5C45 34.9264 34.9264 45 22.5 45C10.0736 45 0 34.9264 0 22.5C0 10.0736 10.0736 0 22.5 0C34.9264 0 45 10.0736 45 22.5Z",
    fill: "#204A22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8305 28.1444C24.8305 28.7279 24.9828 29.1846 25.285 29.5135C25.5895 29.839 25.987 30.0028 26.4786 30.0028C27.1562 30.0028 27.7535 29.8297 28.2684 29.4775L30.1605 34.9854C28.9704 35.6606 27.3433 36 25.2861 36C22.5979 36 20.5291 35.3538 19.0786 34.0556C17.6282 32.7574 16.9053 30.8094 16.9053 28.2165V25.4236C16.9053 23.6198 18.3674 22.1577 20.1711 22.1577H22.6862C23.5056 22.1577 24.2529 21.8369 24.805 21.3139C24.8236 21.2953 24.8445 21.2744 24.8654 21.2558C25.4221 20.6956 25.7673 19.9285 25.7673 19.0766C25.7673 18.2247 25.3965 17.3972 24.805 16.8346C24.2529 16.3116 23.5067 15.9932 22.6862 15.9932H20.1711C18.3674 15.9932 16.9053 14.5311 16.9053 12.7273V10.1436H24.805V12.2147C24.805 14.301 26.4948 15.9943 28.5845 15.9943C29.4306 15.9943 30.2244 16.3407 30.8056 16.8986C31.389 17.4553 31.7574 18.2258 31.7598 19.072C31.7598 19.9262 31.4157 20.6956 30.8532 21.2558C30.2988 21.8125 29.5259 22.1577 28.674 22.1577H28.6322C26.5425 22.1577 24.8526 23.8499 24.8526 25.9373L24.8317 28.1456L24.8305 28.1444Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6752 22.2363C16.4288 22.2363 17.8504 20.8147 17.8504 19.061C17.8504 17.3074 16.4288 15.8858 14.6752 15.8858C12.9216 15.8858 11.5 17.3074 11.5 19.061C11.5 20.8147 12.9216 22.2363 14.6752 22.2363Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwygsAvatarNotification);
export default __webpack_public_path__ + "static/media/twygs-avatar-notification.a5865082c9435fc982354ffca6386c22.svg";
export { ForwardRef as ReactComponent };